import { render, staticRenderFns } from "./materialScience.vue?vue&type=template&id=9a2bb59e&scoped=true"
import script from "./materialScience.vue?vue&type=script&lang=js"
export * from "./materialScience.vue?vue&type=script&lang=js"
import style0 from "./materialScience.vue?vue&type=style&index=0&id=9a2bb59e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2bb59e",
  null
  
)

export default component.exports